<template>
  <div v-if="user && user.type" id="nav" class="md:flex flex-col w-64 h-screen absolute md:relative overflow-auto" :class="{ 'hide-menu': ShowSidebar(), 'vertical-navigation-mode-over': resize() }">
    
    <div class="flex bg-white items-center justify-center sticky top-0 justify-between p-2">
      <router-link class="flex items-center no-active dashbord" to="/">
          <img 
            alt="Logo" 
            class="rounded-full align-middle border-none shadow-lg" 
            :src="brandingLogo || image" 
          />
          <b class="mx-2 font-bold text-lg focus:outline-none font-semibold text-menu" :class="$colors.textPrimary">
            {{ brandingTitle }}
          </b>
          <img class="flag-img" :src="flag" />
        </router-link>
      <button v-if="resize()" @click="actionSidebar" class="focus:outline-none flex items-center inline"><i style="font-size: 30px;" class="material-icons text-blue-600">close</i></button>
    </div>

    <div class="h-full p-2 pt-4 bg-blue-600 text-white img-ss" :class="$colors.sideBar">

      <menu-link v-if="getPermission('dashboard')" to="/" text="Dashboard" class="link" icon="dashboard"/>

      <menu-link v-if="getPermission('warehouses') && getAccess('warehouses', 'create')" to="/warehouses" text="Warehouses" class="link" icon="business" />
      
      <div v-if="['warehouses', 'newWarehouse','regroupements'].indexOf($route.name) > -1 && getAccess('warehouses', 'create')">
          <menu-link to="/warehouses/new" text="New warehouse" icon="add" submenu="true" />
      </div>

      <div v-if="['warehouses', 'newWarehouse','regroupements'].indexOf($route.name) > -1 && getAccess('regroupements', 'create')">
          <menu-link to="/regroupements" text="Regroupements" icon="view_module" submenu="true" />
      </div>

      <menu-link v-if="getPermission('products') && (getAccess('products', 'create') || ['StockManager','AccountManager'].includes(user.type))" to="/products" text="Products" class="link" icon="local_mall" />
      
      <div v-if="['products', 'newProduct'].indexOf($route.name) > -1 && getAccess('products', 'create')">
        <menu-link to="/products/new" text="New product" icon="add" submenu="true" />
      </div>

      <menu-link v-if="$f.getAccessPermission(user, 'analytics', 'create')" to="/callcenter" text="Analytics" class="link" icon="trending_up" />

      <menu-link v-if="getPermission('orders')  && (getAccess('orders', 'create') || ['CallenterManager','TeleConsultant','NRP','AccountManager'].includes(user.type))" to="/orders" text="Orders" class="link" icon="local_grocery_store" />
      
      <div v-if="['orders', 'newOrder'].indexOf($route.name) > -1">
        <menu-link to="/orders/new" v-if="getAccess('orders', 'create')" text="New order" icon="add" submenu="true" />
      </div>

      <menu-link v-if="user.type == 'TeleConsultant' || user.type == 'NRP'" to="/orders/confirmation" text="confirmation" icon="add" />

      <div v-if="['orders', 'importOrders'].indexOf($route.name) > -1">
        <menu-link to="/orders/import" v-if="getAccess('orders', 'create')" text="Import orders" icon="add" submenu="true" />
      </div>

      <div v-if="['orders', 'selleranalytics'].indexOf($route.name) > -1 && user.type !== 'Seller' && $f.getAccessPermission(user, 'SellerAnalytics', 'create')">
        <menu-link to="/orders/selleranalytics" v-if="$f.getAccessPermission(user, 'SellerAnalytics', 'create')" text="Seller Analytics" icon="tune" submenu="true" />
      </div>

      <menu-link v-if="getPermission('expeditions')" to="/expeditions" text="Expeditions" class="link" icon="local_airport" />
      
      <div v-if="['expeditions', 'newExpedition'].indexOf($route.name) > -1">
        <menu-link to="/expeditions/new" text="New Expedition" icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('status') && getAccess('status', 'create')" to="/status" text="Status" class="link" icon="sync" />

      <menu-link v-if="getPermission('users') && (getAccess('users', 'create') || user.type == 'CallenterManager')" :to="'/users?typeuser='+user.type" text="Users" class="link" icon="account_circle" />
      
      <div v-if="['users', 'newUser'].indexOf($route.name) > -1 && getAccess('users', 'create')">
        <menu-link to="/users/new" text="New user" icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('roles') && getAccess('roles', 'update')" to="/roles" text="Roles" class="link" icon="lock" />
      
      <div v-if="['roles', 'newRole'].indexOf($route.name) > -1">
        <menu-link to="/roles/new" text="New role " icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('teams')" to="/teams" text="Teams" class="link" icon="group" />

      <div v-if="['teams', 'newTeam'].indexOf($route.name) > -1">
        <menu-link to="/teams/new" text="New team " icon="add" submenu="true" />
      </div>

      <menu-link v-if="getPermission('subscribers')" to="/subscribers" text="Subscribers" class="link" icon="supervisor_account" />
      
      <div v-if="['subscribers', 'newSubscribers'].indexOf($route.name) > -1 && getAccess('subscribers', 'create')">
        <menu-link to="/subscribers/new" text="New subscriber" icon="add" submenu="true" />
      </div>

      <menu-link v-if="((getPermission('zones') || getPermission('shippings')) && getAccess('zones', 'create')) || ['Accountant','AccountManager'].includes(user.type) || (user.type == 'Seller' && getAccess('shippings', 'read'))" to="#" text="Shipping order" class="link" icon="local_shipping" :isActive="isActive" @myFilter="myFilter" />
      
      <menu-link v-if="getPermission('zones') && getAccess('zones', 'create')" to="/zones" text="Zones" class="link" icon="map" children="true" />
      
      <div v-if="['zones', 'newZones'].indexOf($route.name) > -1">
        <menu-link to="/zones/new" text="New Zone" icon="add" class="child" submenu="true" />
      </div>
    
      <menu-link v-if="(getPermission('shippings') && (getAccess('shippings', 'create') || (['StockManager','Courier','AccountManager'].includes(user.type)))) || (user.type == 'Seller' && getAccess('shippings', 'read'))" to="/shippings" text="Shippings" class="link" icon="map" children="true" />

       <menu-link v-if="getAccess('sourcings', 'update')" to="/sourcings" text="Sourcings" class="link" icon="find_in_page" />

      <menu-link v-if="getPermission('payments') || getPermission('refunds')" :to="'/payments?typeuser='+user.type" text="Payments" class="link" icon="payment" />

      <div v-if="['payments', 'newPayments','multiWarehouses','refunds','avoirs'].indexOf($route.name) > -1 && (getAccess('payments', 'create') || getAccess('payments', 'update'))">
        <menu-link to="/payments/new" text="New payment" icon="add" submenu="true" />
      </div>

      <div v-if="['payments', 'newPayments','multiWarehouses','refunds','avoirs'].indexOf($route.name) > -1 && (getAccess('payments', 'create') || getAccess('payments', 'update'))">
        <menu-link to="/payments/multiwarehouses" text="Multi warehouses" icon="tune" submenu="true" />
      </div>

      <div v-if="['payments', 'refunds','multiWarehouses','avoirs','newPayments'].indexOf($route.name) > -1 && (getAccess('refunds', 'create') || getAccess('refunds', 'read'))">
        <menu-link to="/refunds" text="Refunds" icon="strikethrough_s" submenu="true" />
      </div>

      <!-- <div v-if="['payments', 'sourcings','multiWarehouses','refunds','avoirs','newPayments'].indexOf($route.name) > -1 && getAccess('sourcings', 'create')">
        <menu-link to="/sourcings" text="Sourcings" icon="monetization_on" submenu="true" />
      </div> -->

      <div v-if="['payments', 'sourcings','multiWarehouses','refunds','avoirs','newPayments'].indexOf($route.name) > -1 && getAccess('avoirs', 'create')">
          <menu-link to="/avoirs" text="Avoirs" icon="card_giftcard" submenu="true" />
      </div>

      <!-- Tickets -->
      <menu-link v-if="getPermission('tickets')" to="/tickets" text="Tickets" class="link" icon="confirmation_number" />

      <div v-if="['tickets', 'newTicket'].indexOf($route.name) > -1">
        <menu-link to="/tickets/new" text="New ticket" icon="add" submenu="true" />
      </div>
      <!-- Tickets -->
      
      <menu-link v-if="getPermission('settings') && (getAccess('settings', 'update') || (user.type == 'Seller' && getAccess('settings', 'read')))" to="/settings" text="Settings" class="link" icon="settings" />

      <menu-link v-if="getPermission('senders')  && getAccess('senders', 'create')" to="/senders" text="Whatsapp sender" class="link img" img="https://storeno.b-cdn.net/shipsen/11-2021/1638273178072.png" imghover="https://storeno.b-cdn.net/shipsen/11-2021/1638273222191.png"/>
      
      <menu-link v-if="user.type == 'Seller'" to="https://storeino.com" :isLinkHref="true" text="Create Store" class="link img" img="https://storeno.b-cdn.net/shipsen/10-2021/1633356154211.png" imghover="https://storeno.b-cdn.net/shipsen/10-2021/1633356552917.png" target="_blank" />
      
      <menu-link to="/orders/api" v-if="user.type == 'Admin' || user.type == 'Seller'" text="API" icon="import_export" class="link"/>

    </div>
  </div>
</template>

<script>
import image from "@/assets/shipsen-man.jpg";
export default {
  data() {
    return {
      login: false,
      token: null,
      //user: { role: {} },
      isActive: false,
      status: false,
      hideMenu: false,
      image: image,
      flag: "https://img.icons8.com/material-outlined/2x/image.png",
      brandingLogo: null,
      brandingTitle: 'ShipSen',
    };
  },
  props: {
    idWharhouse: { type: Object },
    user: { type: Object },
  },
  async mounted() {
    //this.login=this.$jwtService.verifyToken()
    this.token = this.$jwtService.getToken();
   // await this.getUser();
    this.getAccess("users", "read");
    this.getFlag();
    this.loadBranding();
  },
  watch: {
    'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          this.getFlag();
      },
      idWharhouse: {
        handler() {
          this.getFlag();
          this.loadBranding();
        },
        deep: true
      },
      'user.role': {
        handler() {
          this.loadBranding();
        },
        deep: true
      }
  },
  methods: {
    loadBranding() {
      if (this.idWharhouse && this.user.role && this.user.role.branding && this.idWharhouse._id) {
        const branding = this.user.role.branding.find(
          b => b.warehouse === this.idWharhouse._id || b.warehouse._id === this.idWharhouse._id || b.country === this.idWharhouse.country
        );
        
        if (branding) {
          this.brandingLogo = branding.logo || null;
          this.brandingTitle = branding.title || 'ShipSen';
        } else {
          this.brandingLogo = null;
          this.brandingTitle = 'ShipSen';
        }
      }
    },
    getFlag() {
      this.flag = this.idWharhouse.flag || this.$f.getCountryCode(this.idWharhouse.country);
    },
    ShowSidebar() {
      return this.$store.getters.ShowSidebar;
    },
    actionSidebar() {
      this.$store.dispatch("actionSidebar");
    },
    resize() {
      return this.$store.getters.resize;
    },
    myFilter: function() {
      this.isActive = !this.isActive;
      // some code to filter users
    },
    async getStatusUser() {
      if (this.user.status == "active") {
        this.status = true;
      } else {
        this.status = false;
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.user = res.content;
      else this.user = [];
    },
    logout() {
      this.$jwtService.destroyToken();
      location.href = "/";
      //this.$router.push("home");
    },
    getAccess(modelToCheck, accessToCheck) {
      const permissions = this.user.role.permissions;
      for (let i in permissions) {
        let model = permissions[i]["model"];
        let access = permissions[i]["access"];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
    getPermission(name) {
      if (this.user) {
        const permissions = this.user.role.permissions;
        for (let i in permissions) {
          let model = permissions[i]["model"];
          let access = permissions[i]["access"];

          if (model == name) {
            if (access.create || access.read || access.update || access.delete) {
              // console.log("authorized",model);
              return true;
            } else {
              //console.log("not authorized",model);
              return false;
            }
          }
        }
      }
    },
  },
};
</script>

<style>
.vertical-navigation-mode-over {
  position: fixed !important;
  transform: translateZ(0);
  left: 0 !important;
  top: 0 !important;
  bottom: 0;
}
.dashbord img {
  width: 40px;
}
.link:hover {
  background-color: white;
  color: dodgerblue;
  border-radius: 6px;
  /* font-weight: bold; */
}
.img-link img:last-child {
  display: none;
}
.link:hover img:last-child {
  display: block;
}
.link:hover img:first-child {
  display: none;
}
.link .router-link-active img:first-child {
  display: none;
}
.link .router-link-active img:last-child {
  display: block;
}
#nav {
  transition-duration: 0.4s;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-property: visibility, margin-left, margin-right, transform, width, max-width, min-width;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #3182ce;
  position: sticky;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  top: 0;
  width: 260px;
  min-width: 260px;
  max-width: 260px;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  z-index: 10;
}
</style>
